import { environment } from "env/environment";
import { NgxZendeskWebwidgetConfig } from "../chat/zendesk-webwidget/zendesk-webwidget.model";

export class ZendeskConfig extends NgxZendeskWebwidgetConfig {
  accountUrl = environment.zendescAccountUrl;
  callback(zE: any) {
    zE('webWidget', 'hide');
    zE('webWidget:on', 'close', () => {
    zE('webWidget', 'hide');
    });
  }
}